/**
 * HelpTopicPage — /help/topics/:category: every current article of one help topic (US-6), at reading
 * width. Reached from a topic card on the help center; each row opens the article at /help/:id.
 */

import { Link, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useHelp } from '../components/help/HelpProvider';
import { TopicArticles } from '../components/help/TopicArticles';

export function HelpTopicPage() {
  const { category } = useParams<{ category: string }>();
  const { chatDisabled } = useHelp();

  return (
    <div className="mx-auto flex max-w-2xl flex-col gap-4 px-[var(--page-padding-x)] pb-6" data-testid="help-topic-page">
      <Link
        to="/help"
        data-testid="help-topic-back"
        className="inline-flex min-h-[44px] items-center gap-1 self-start text-sm text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        Help center
      </Link>

      {category && <TopicArticles key={category} category={category} showHeading />}

      <div className="flex flex-wrap items-center gap-2 border-t border-border pt-2">
        {!chatDisabled && (
          <Button asChild variant="ghost" className="text-primary">
            <Link to="/help/chat" data-testid="help-topic-page-ask">
              Ask a question
            </Link>
          </Button>
        )}
        <Button asChild variant="ghost" className="text-primary">
          <Link to="/support" data-testid="help-topic-page-contact">
            Contact support
          </Link>
        </Button>
      </div>
    </div>
  );
}
